import { useLocation } from 'react-router-dom';
import { useAppSelector } from '@/hooks';

export const useNavbarVisibility = () => {
  const { user } = useAppSelector((state) => state.auth);
  const location = useLocation();

  const isNavbarVisible = () => {
    if (!user) return false;

    const isMobile = window.innerWidth < 640;
    const doNotShowNavBar =
      location.pathname.includes('/inventory') ||
      location.pathname.includes('/customers') ||
      location.pathname.includes('/create-invoice') ||
      location.pathname.includes('/invoices') ||
      location.pathname.includes('/invoice-report') ||
      location.pathname.includes('/customer-engagement') ||
      location.pathname.includes('/ledger') ||
      location.pathname.includes('/sales') ||
      location.pathname.includes('/settings') ||
      location.pathname === '/profile' ||
      location.pathname.includes('/tools/poster-sharing') ||
      location.pathname.includes('/tools/poster-config') ||
      location.pathname.includes('/tools/online-store') ||
      location.pathname.includes('/tools/image-to-invoice') ||
      location.pathname.includes('/insights') ||
      location.pathname.includes('/customer-orders/') ||
      location.pathname.includes('/buyer/') ||
      location.pathname.includes('/store/') ||
      location.pathname.includes('/munshi-chat');

    // Hide navbar on mobile for pages that don't need it
    if (isMobile && doNotShowNavBar) return false;

    return !isMobile || !doNotShowNavBar;
  };

  return { isNavbarVisible };
}; 